import styled from 'styled-components/macro';

const Comment = styled.div`
  font-size: ${props => props.theme.sizes.xs};
  font-weight: ${props => props.theme.weight.xbase};
  color: ${props => props.theme.colors.baseLighterS};
`;

export default Comment;
